
import * as THREE from 'three'
require('three-orbitcontrols');
import { BufferGeometryUtils } from '../../../3dapps/libs/BufferGeometryUtils';
import { threeFonts, loadFontGlyphs } from '../../../3dapps/js/fontManage';

export var scene;//相机
export var camera;//场景
export var renderer;//渲染器
var controls;//控制器

export let currentMesh;
let renderCount = -1;

import tidepool_negx_2 from '@/3dapps/skybox/tidepool/negx_2.jpg';
import tidepool_negy_2 from '@/3dapps/skybox/tidepool/negy_2.jpg';
import tidepool_negz_2 from '@/3dapps/skybox/tidepool/negz_2.jpg';
import tidepool_posx_2 from '@/3dapps/skybox/tidepool/posx_2.jpg';
import tidepool_posy_2 from '@/3dapps/skybox/tidepool/posy_2.jpg';
import tidepool_posz_2 from '@/3dapps/skybox/tidepool/posz_2.jpg';

function incRenderCount() {
    renderCount += 2;
}

function addSkyBox(scene, imgs) {
    new THREE.CubeTextureLoader().load(imgs, function (texture) { scene.background = texture; incRenderCount(); });
}

export function initThree(canvas3dworld) {
    scene = new THREE.Scene();
    //创建3D世界
    var w = canvas3dworld.scrollWidth;
    var h = canvas3dworld.scrollHeight;

    //创建渲染器
    renderer = new THREE.WebGLRenderer({
        canvas: canvas3dworld,
        antialias: true,//抗锯齿
        preserveDrawingBuffer: true,//3D加上这个在缩略图中可以变成白色
    });
    renderer.setSize(w, h);
    renderer.setClearColor(new THREE.Color("#778A99"));//把渲染器的背景变成白色
    renderer.setPixelRatio(2);

    // 创建场景
    // 量纲，单位 1px 1m 1kg
    camera = new THREE.PerspectiveCamera(70, w / h, 0.1, 2200);

    //定义相机的x,y,z位置
    camera.position.y = 280;
    camera.position.z = 140;
    camera.lookAt(scene.position);//把相机的位置渲染到场景中


    //控制器，鼠标左键和右键，滑轮操作
    controls = new THREE.OrbitControls(camera, canvas3dworld);
    
    controls.addEventListener("change", function () {
        renderCount += 2;
        // console.log(camera.position.x, camera.position.y, camera.position.z);
    });

    //是否可以缩放
    controls.enableZoom = true;
    //设置相机距离原点的最远距离
    controls.minDistance = 20;
    controls.maxDistance = 700;

    //渲染场景
    function animate() {
        requestAnimationFrame(animate);
        renderer.render(scene, camera);
    }
    animate();

    // 从一个点向各个方向发射的光源
    var bluePoint = new THREE.PointLight(0xffffff, 1.5, 150);
    bluePoint.position.set(10, 200, 10);
    scene.add(bluePoint);

    // 环境光会均匀的照亮场景中的所有物体。
    var light = new THREE.AmbientLight(0xffffff, 1.2); // soft white light
    scene.add(light); 

    addSkyBox(scene, [
        tidepool_negx_2,
        tidepool_posx_2,
        tidepool_posy_2,
        tidepool_negy_2,
        tidepool_negz_2,
        tidepool_posz_2,
    ]);
}

export function updateModel(vue, data) {
    return loadFontGlyphs(vue, data.font, data.text).catch(err => {
    }).then(() => {
        makeText(data);
    });
}


const material = new THREE.MeshPhongMaterial({
    color: 0x333333,
    reflectivity: 1,
});

const material2 = new THREE.MeshPhongMaterial({
    color: 0xb66c3b,
    reflectivity: 1,
});

let bambooSlipMesh = null;

const punctuations = new Map();
punctuations.set("，", {
    top: 0.4,
    bottom: -0.1,
});
punctuations.set("、", {
    top: 0.4,
    bottom: -0.1,
});
punctuations.set("。", {
    top: 0.4,
    bottom: -0.1,
});
punctuations.set("“", {
    top: -0.1,
    bottom: 0.4,
});
punctuations.set("”", {
    top: -0.1,
    bottom: 0.3,
});

function createPath(char, scale, offsetX, offsetY, data, defaultData) {

    var glyph = data.glyphs[char] || (defaultData ? defaultData.glyphs[char] : undefined) || data.glyphs['?'];

    if (!glyph) {

        console.error('THREE.Font: character "' + char + '" does not exists in font family ' + data.familyName + '.');

        return;

    }

    var centerX = offsetX + (glyph.x_min + glyph.x_max) * 0.5 * scale;
    var centerX2 = offsetX + glyph.ha * 0.5 * scale;
    offsetX += centerX2 - centerX;

    var path = new THREE.ShapePath();

    var x, y, cpx, cpy, cpx1, cpy1, cpx2, cpy2;

    if (glyph.o) {

        var outline = glyph._cachedOutline || (glyph._cachedOutline = glyph.o.split(' '));

        for (var i = 0, l = outline.length; i < l;) {

            var action = outline[i++];

            switch (action) {

                case 'm': // moveTo

                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;

                    path.moveTo(x, y);

                    break;

                case 'l': // lineTo

                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;

                    path.lineTo(x, y);

                    break;

                case 'q': // quadraticCurveTo

                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;

                    path.quadraticCurveTo(cpx1, cpy1, cpx, cpy);

                    break;

                case 'b': // bezierCurveTo

                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    cpx2 = outline[i++] * scale + offsetX;
                    cpy2 = outline[i++] * scale + offsetY;

                    path.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);

                    break;

            }

        }

    }

    return {
        offsetX: glyph.ha * scale,
        path: path
    };

}

function makeText(data) {
    if (bambooSlipMesh) {
        scene.remove(bambooSlipMesh);
        bambooSlipMesh = null;
    }
    //console.log("currentMesh", bambooSlipMesh);

    const w = data.w - data.p1 * 2; // 字体宽度
    const h = data.h - data.p2 * 2; // 文本总高度
    const fontData = threeFonts[data.font].data;
    let scale = w / (fontData.boundingBox.xMax - fontData.boundingBox.xMin);
    let line_height = (fontData.boundingBox.yMax - fontData.boundingBox.yMin + fontData.underlineThickness) * scale;
    const shiftY = 0.1;
    let offsetX = 0, offsetY = -line_height * (1 - shiftY);
    let lastOffsetY = offsetY - line_height;
    let lastBottom = lastOffsetY;
    let baseCnt = 1;

    let columns = [[]];
    let index = 0;
    for (let ch of data.text) {
        if (ch === '\n') {
            offsetX += data.w * 1.2;
            offsetY = -line_height * (1 - shiftY);
            lastOffsetY = offsetY - line_height;
            baseCnt++;
            index++;
            columns[index] = [];
        } else if (ch === ' ') {
            lastOffsetY = offsetY;
            offsetY -= line_height * 0.6;
        } else {
            let yChange = -line_height;
            if (punctuations.has(ch)) {
                let change = punctuations.get(ch);
                offsetY += line_height * change.top;
                yChange += line_height * change.bottom;
            }

            let path = createPath(ch, scale, offsetX, offsetY, fontData);
            let shapes = path.path.toShapes();
            let y1 = Infinity, y2 = -Infinity;
            for (let shape of shapes) {
                let points = shape.extractPoints(12).shape;
                for (let p of points) {
                    y1 = Math.min(y1, p.y);
                    y2 = Math.max(y2, p.y);
                }
            }
            lastBottom = y1;
            if (lastBottom < -h) {
                offsetY = -line_height * (1 - shiftY);
                offsetX += data.w * 1.2;
                index++;
                columns[index] = [];

                path = createPath(ch, scale, offsetX, offsetY, fontData);
                let shapes = path.path.toShapes();
                let y1 = Infinity, y2 = -Infinity;
                for (let shape of shapes) {
                    let points = shape.extractPoints(12).shape;
                    for (let p of points) {
                        y1 = Math.min(y1, p.y);
                        y2 = Math.max(y2, p.y);
                    }
                }
                lastBottom = y1;
                baseCnt++;
            }

            columns[index].push(path);
            lastOffsetY = offsetY;
            offsetY += yChange;
        }
    }

    let textGeomList = [];
    for (let i in columns) {
        let shapes = [];
        let center = data.w * 1.2 * i + data.w * 0.5;
        for (let path of columns[i]) {
            shapes.push(...path.path.toShapes());
        }
        let geom = new THREE.ExtrudeBufferGeometry(shapes, {
            depth: data.t,
            bevelEnabled: false
        });

        geom.computeBoundingBox();
        let center1 = (geom.boundingBox.min.x + geom.boundingBox.max.x) * 0.5;

        geom.translate(center - center1, h + data.p2, data.t - 1);

        textGeomList.push(geom);
    }

    let geom1 = BufferGeometryUtils.mergeBufferGeometries(textGeomList);
    let baseMesh = new THREE.Mesh(geom1, material);

    let rect = new THREE.Shape();
    rect.moveTo(-data.w * 0.5, -data.h * 0.5);
    rect.lineTo(data.w * 0.5, -data.h * 0.5);
    rect.lineTo(data.w * 0.5, data.h * 0.5);
    rect.lineTo(-data.w * 0.5, data.h * 0.5);
    rect.lineTo(-data.w * 0.5, -data.h * 0.5);
    let circleRadius = data.r;
    let circleShape1 = new THREE.Shape();
    circleShape1.absarc(0, data.h * 0.5 - data.p2 * 0.7, circleRadius, 0, Math.PI * 2, false);
    let circleShape2 = new THREE.Shape();
    circleShape2.absarc(0, - data.h * 0.5 + data.p2 * 0.7, circleRadius, 0, Math.PI * 2, false);
    rect.holes.push(circleShape1, circleShape2);
    window.a = THREE;
    let geom2 = new THREE.ExtrudeBufferGeometry(rect, {
        depth: data.t,
        bevelEnabled: false
    });
    geom2.translate(data.w * 0.5, data.h * 0.5, 0);

    let geomList = [geom2];
    for (let i = 1; i < baseCnt; i++) {
        let geom = geom2.clone();
        geom.translate(i * data.w * 1.2, 0, 0);
        geomList.push(geom);
    }


    bambooSlipMesh = new THREE.Group();
    let textGeom = BufferGeometryUtils.mergeBufferGeometries(geomList);
    let textMesh = new THREE.Mesh(textGeom, material2);
    bambooSlipMesh.add(baseMesh);
    bambooSlipMesh.add(textMesh);
    bambooSlipMesh.rotation.x = - Math.PI * 0.5;
    bambooSlipMesh.position.x = -((baseCnt - 1) * w * 1.8 + data.w) * 0.5;
    bambooSlipMesh.position.z = data.h * 0.5;
    scene.add(bambooSlipMesh);

    currentMesh = bambooSlipMesh;
}



// WEBPACK FOOTER //
// ./src/views/bamboo3d/script/initThree.js